import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  searchString: "",
  employeeVoluntaryOTFoundByReferenceNumberSearch: null,
  employeeVoluntaryOTFoundByReferenceNumberSearchIsLoading: false,
  employeeVoluntaryOTFoundByReferenceNumberSearchIsDialogOpen: false,
  searchStringErrors: "",
  selectedWorkgroup: "",
  availableWorkgroups: [],
  selectedDate: null,
};

export const employeeVoluntaryOTSlice = createSlice({
  name: "employeeVoluntaryOT",
  initialState,
  reducers: {
    updateSearchString: (state, action) => {
      state.searchString = action.payload;
    },
    updateEmployeeVoluntaryOTFoundByReferenceNumberSearch: (state, action) => {
      state.employeeVoluntaryOTFoundByReferenceNumberSearch = action.payload;
    },
    updateEmployeeVoluntaryOTFoundByReferenceNumberSearchIsLoading: (state, action) => {
      state.employeeVoluntaryOTFoundByReferenceNumberSearchIsLoading = action.payload;
    },
    updateEmployeeVoluntaryOTFoundByReferenceNumberSearchIsDialogOpen: (state, action) => {
      state.employeeVoluntaryOTFoundByReferenceNumberSearchIsDialogOpen = action.payload;
    },
    updateSearchStringErrors: (state, action) => {
      state.searchStringErrors = action.payload;
    },
    updateSelectedWorkgroup: (state, action) => {
      state.selectedWorkgroup = action.payload;
    },
    updateAvailableWorkgroups: (state, action) => {
      state.availableWorkgroups = action.payload;
    },
    updateSelectedDate: (state, action) => {
      state.selectedDate = action.payload;
    },
    clearAllEmployeeVoluntaryOTFilters: () => initialState,
  },
});

export const {
  updateSearchString,
  updateEmployeeVoluntaryOTFoundByReferenceNumberSearch,
  updateEmployeeVoluntaryOTFoundByReferenceNumberSearchIsLoading,
  updateEmployeeVoluntaryOTFoundByReferenceNumberSearchIsDialogOpen,
  updateSearchStringErrors,
  clearAllEmployeeVoluntaryOTFilters,
  updateSelectedWorkgroup,
  updateSelectedDate,
  updateAvailableWorkgroups,
} = employeeVoluntaryOTSlice.actions;

export const selectEmployeeVoluntaryOTData = (state) => state.employeeVoluntaryOT;

export default employeeVoluntaryOTSlice.reducer;
